import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { ProductionOrderRequest } from './common/productionOrderRequest';
import type { ProductionOrder } from 'shared/productionOrders/domain/productionOrder';

export interface UpdateProductionOrderRequest extends ProductionOrderRequest {
  id: string;
}

export interface UpdateProductionOrderResponse {
  ok: true;
  productionOrder: ProductionOrder;
}

export function useUpdateProductionOrderApi() {
  return useUpdateEntityApi<UpdateProductionOrderRequest, UpdateProductionOrderResponse>({
    url: 'productionorder',
    translate: (t) => t.productionOrders.actions.update,
    async processOk(response) {
      const json = (await response.json()) as ProductionOrder;
      return {
        ok: true,
        productionOrder: json,
      };
    },
  });
}
